<div id="overlay">
  <div class="modal-widget">
    <div class="header">
      <button type="button" class="close" (click)="modalService.showModal = false">Close</button>
    </div>
    <div class="title">Not so fast…</div>
    <div class="text">Do you wish to exit without saving your changes?</div>
    <div class="footer">
      <button type="button" class="btnSubmit" (click)="cancel()">Yes</button>
      <button type="button" class="btnCancel" (click)="modalService.showModal = false">No</button>
    </div>
  </div>
</div>
